const slugify = require( 'slugify' )

const SITE_LEGACY_PATH = process.env.GATSBY_SITE_LEGACY_PATH
const ALTERNATIVE_CHECKOUT = process.env.GATSBY_ALTERNATIVE_CHECKOUT

const sitePartnerCode = '4fwVPdRk63zgSeCN14z6GW1lvw5p30n7p5F1pYehSoyXW_d9yk4ntxgpzEnGMvsmfyA'
const curadoria = `${process.env.GATSBY_SITE_PATH}curadoria/`
const ineditos = `${process.env.GATSBY_SITE_PATH}ineditos/`
const curadoriaKitsPassados = `${process.env.GATSBY_SITE_PATH}kits-passados/curadoria/`
const ineditosKitsPassados = `${process.env.GATSBY_SITE_PATH}kits-passados/ineditos/`
const proximoKit = `${SITE_LEGACY_PATH}/proximo-kit`
const proximoKitClube = 'https://clube.taglivros.com/proximo-kit/curadoria-ineditos/'
const proximosKits = `${SITE_LEGACY_PATH}/proximo-kit/curadoria-ineditos`
const desafio1LivroPorMes = `${SITE_LEGACY_PATH}/desafio1livropormes`
const blog = `${SITE_LEGACY_PATH}/blog`
const privacidadeESeguranca = 'https://clube.taglivros.com/politica-de-privacidade-e-seguranca/'
const privacidadeTermosRegulamento = 'https://duvidas.taglivros.com/pt-BR/articles/5920975-termos-de-uso-politicas-de-privacidade-e-regulamentos'
const english = `${SITE_LEGACY_PATH}/en`
const login = `${SITE_LEGACY_PATH}/login`
const associese = `${process.env.GATSBY_SITE_PATH}associe-se/escolha-sua-caixinha/?partner_code=${sitePartnerCode}`
const chat = `${SITE_LEGACY_PATH}/chat`
const kitsPassados = `${process.env.GATSBY_SITE_PATH}kits-passados/`
const trilhasTAG = 'https://www.doispontos.com.br/busca?fq=H:729'
const storeTag = 'https://loja.taglivros.com/kits-anteriores'
const adaLogin = `${SITE_LEGACY_PATH}/area-do-associado/login`
const alternativeCheckout = `${ALTERNATIVE_CHECKOUT}/?partner_code=${sitePartnerCode}`
const alternativeIneditos = 'https://leia.taglivros.com/experimente-clube-2024/'
const caixaFantastica = 'https://loja.taglivros.com/pre-venda-caixa-fantastica-tag-galera/?utm_source=home'
const sciFi = `https://colecao.taglivros.com/sci-fi/?partner_code=${sitePartnerCode}`
const onePageCheckout = `${process.env.GATSBY_SITE_PATH}checkout/`
const onePageCheckoutWithPartnerCode = `${onePageCheckout}?partner_code=${sitePartnerCode}`
const sciFiCheckout = `${onePageCheckout}?product=scifi&partner_code=${sitePartnerCode}`
const subscriptionAnchor = `#club-subscription-anchor`
const lpBookster = `${process.env.GATSBY_LPBOOKSTER_URL}`
const lpAtlasDoFeminino = `${process.env.GATSBY_LP_ATLAS_DO_FEMININO_URL}`
const livraria = `https://livraria.taglivros.com/`

const generateSlugPreviousKits = ( category, title ) => {
  return `${kitsPassados}${category}/${slugify( title, {
    'lower': true
  } )}/`
}

export {
  curadoria,
  ineditos,
  curadoriaKitsPassados,
  ineditosKitsPassados,
  proximoKit,
  proximoKitClube,
  proximosKits,
  desafio1LivroPorMes,
  blog,
  privacidadeESeguranca,
  english,
  associese,
  login,
  chat,
  kitsPassados,
  trilhasTAG,
  storeTag,
  privacidadeTermosRegulamento,
  adaLogin,
  alternativeCheckout,
  alternativeIneditos,
  caixaFantastica,
  sciFi,
  onePageCheckout,
  onePageCheckoutWithPartnerCode,
  sciFiCheckout,
  subscriptionAnchor,
  sitePartnerCode,
  lpBookster,
  lpAtlasDoFeminino,
  livraria,
  generateSlugPreviousKits,
}
